export const queryPage = '/transfer/outer/transfer/datatask/query_page'
export const saveOrUpdate = '/transfer/outer/transfer/datatask/save_or_update'
import request from '@/utils/request'
export function update_status(params) {
  return request({
    url: '/transfer/outer/transfer/datatask/update_status',
    method: 'get',
    params
  })
}
/**根据数据id获取任务详情*/
export function get_detail(params) {
  return request({
    url: '/transfer/outer/transfer/datatask/get_detail',
    method: 'get',
    params
  })
}
/**获取数据源列表*/
export function get_list(params) {
  return request({
    url: '/transfer/outer/transfer/datasource/get_list',
    method: 'get',
    params
  })
}
/**根据数据源id获取数据表*/
export function get_table_list(params) {
  return request({
    url: '/transfer/outer/transfer/datasource/get_table_list',
    method: 'get',
    params
  })
}
/**根据数据源id和表名称获取字段列表*/
export function get_field_list(params) {
  return request({
    url: '/transfer/outer/transfer/datasource/get_field_list',
    method: 'get',
    params
  })
}
/**根据数据id立即执行任务*/
export function exec_task(params) {
  return request({
    url: '/transfer/outer/transfer/datatask/exec_task',
    method: 'get',
    params
  })
}